import { render } from "./order_status.vue?vue&type=template&id=4ba5cba0"
import script from "./order_status.vue?vue&type=script&lang=js"
export * from "./order_status.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__